module.exports = __webpack_public_path__ + "img/KSC02641.77127751.jpg";